import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { AssignmentRulesMatrixSearchSchema } from '../../-zod-schema';
export const Route = createFileRoute('/_staff/equipment/_layout/rule-and-policy/_layout/assignment/')({
  validateSearch: zodValidator(AssignmentRulesMatrixSearchSchema)
});